module.exports = __webpack_public_path__ + "static/media/preview.48122011.webp";